// @flow
import React from 'react'
import { Transition } from 'react-transition-group'
import Popper from '../../Popper'
import { Container, Arrow } from './elements'
import type { Props as BaseProps, RenderProps } from '../SelectorButton'

type Props = BaseProps &
  RenderProps & {
    selectorShowed: boolean,
  }

const DesktopSelector = ({
  selectorShowed,
  open,
  close,
  appearance,
  color,
  placement,
  width,
  wrapper,
  renderButton,
  renderSelector,
}: Props) => {
  const params = {
    appearance,
    open,
    close,
  }

  return (
    <Popper
      showed={selectorShowed}
      wrapper={wrapper}
      placement={placement}
      onHidePopper={close}
      target={(innerRef, { onClick, onFocus }) => (
        <div onClick={onClick} onFocus={onFocus} ref={innerRef}>
          {renderButton(params)}
        </div>
      )}
      arrow={(innerRef, arrowProps, { placement: arrowPlacement }) => (
        <Arrow
          {...arrowProps}
          ref={innerRef}
          $placement={arrowPlacement}
          $color={color}
        />
      )}
      popper={(innerRef, { style, children }, { roughPlacement, showed }) => (
        <Transition
          in={showed}
          timeout={{ enter: 1, exit: 650 }}
          mountOnEnter
          unmountOnExit
        >
          {(state) => (
            <Container
              style={style}
              ref={innerRef}
              $placement={roughPlacement}
              $width={width}
              $color={color}
              $showed={state === 'entered'}
            >
              {children}
              {renderSelector(params)}
            </Container>
          )}
        </Transition>
      )}
    />
  )
}

export default DesktopSelector
